// extracted by mini-css-extract-plugin
export default {"language_container":"selecteur_de_langue_language_container__K1yAH","language_button":"selecteur_de_langue_language_button__XKfeN"};